module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Fork-spoon-knife-d414553e14e9cdb01de5ba12c5fa39bf.svg";